import React from "react";
import { Modal, Table, Tag, Progress } from "antd";

const statusColor = {
    pending: "default",
    processing: "blue",
    success: "green",
    failed: "red",
    skipped: "orange",
};

export default function BatchProgressModal({
    open,
    onClose,
    items, // [{id, label, status, message}]
}) {
    const total = items.length;
    const done = items.filter((x) => x.status !== "pending" && x.status !== "processing").length;
    const percent = total ? Math.round((done / total) * 100) : 0;

    const columns = [
        { title: "ID", dataIndex: "id", width: 100 },
        { title: "Нэр", dataIndex: "label" },
        {
            title: "Төлөв",
            dataIndex: "status",
            width: 140,
            render: (v) => <Tag color={statusColor[v] || "default"}>{v}</Tag>,
        },
        {
            title: "Мессеж",
            dataIndex: "message",
            ellipsis: true,
        },
    ];

    return (
        <Modal
            title="Багц ажиллагаа"
            open={open}
            onCancel={onClose}
            footer={null}
            width={900}
        >
            <div style={{ marginBottom: 12 }}>
                <Progress percent={percent} />
            </div>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={items}
                pagination={false}
                size="small"
                scroll={{ y: 360 }}
            />
        </Modal>
    );
}